import { subscriptionConstants as sc } from 'srcReact/SubscriptionPage'
import { commonConstants as cc } from 'srcReact/components'

const initialState = {
  ask_access_page: '',
  authorized: false,
  subscriptionPlanList: [],
  subscriptionPlanListSuccess: false,
  subscriptionPlanListFailure: false,
  currency: {
    loading: false,
    error: null,
    data: null
  }
}

export function subscription(state = initialState, action) {
  switch (action.type) {
    //case sc.CREATE_SUBSCRIPTION_REQUEST:
    case sc.CREATE_SUBSCRIPTION_AFTER_CHECKOUT_REQUEST:
      return {
        ...state,
        subscriptionPlan: {
          loading: true,
        },
      }
    // case sc.CREATE_SUBSCRIPTION_SUCCESS:
    case sc.CREATE_SUBSCRIPTION_AFTER_CHECKOUT_SUCCESS:
      return {
        ...state,
        subscriptionPlan: {
          loading: false,
          loaded: true,
        },
      }
    // case sc.CREATE_SUBSCRIPTION_FAILURE:
    case sc.CREATE_SUBSCRIPTION_AFTER_CHECKOUT_FAILURE:
      return {
        ...state,
        subscriptionPlan: {
          loading: false,
          loaded: false,
          error: true,
        },
      }

    //  case sc.UPDATE_SUBSCRIPTION_REQUEST:
    case sc.UPDATE_SUBSCRIPTION_AFTER_CHECKOUT_REQUEST:
      return {
        ...state,
        subscriptionPlan: {
          loading: true,
        },
      }
    //  case sc.UPDATE_SUBSCRIPTION_SUCCESS:
    case sc.UPDATE_SUBSCRIPTION_AFTER_CHECKOUT_SUCCESS:
      return {
        ...state,
        subscriptionPlan: {
          loading: false,
          updated: true,
        },
      }
    // case sc.UPDATE_SUBSCRIPTION_FAILURE:
    case sc.UPDATE_SUBSCRIPTION_AFTER_CHECKOUT_FAILURE:
      return {
        ...state,
        subscriptionPlan: {
          loading: false,
          updated: false,
          error: true,
        },
      }

    case sc.GET_PLAN_UPDATE_LIST_SUCCESS:
      return {
        ...state,
        subscriptionPlanList: action.response.new_plans,
        subscriptionPlanListSuccess: true,
        subscriptionPlanListFailure: false,
      }
    case sc.GET_PLAN_UPDATE_LIST_FAILURE:
      return {
        ...state,
        subscriptionPlanListSuccess: false,
        subscriptionPlanListFailure: true,
      }

    case sc.UPDATE_PLAN_REQUEST:
      return {
        ...state,
        subscriptionPlan: {
          loading: true,
          loaded: false,
          error: false,
        },
      }

    case sc.UPDATE_PLAN_SUCCESS:
      const { responseUpdatePlan } = action.response
      return {
        ...state,
        subscriptionPlanList: action.response.responsePlanUpdateList.new_plans,
        subscriptionPlanListSuccess: true,
        subscriptionPlanListFailure: false,
        subscriptionPlan: {
          loading: false,
          loaded: true,
          error: false,
          update_infos: responseUpdatePlan ? responseUpdatePlan.update_infos : null,
        },
      }

    case sc.UPDATE_PLAN_FAILURE:
      return {
        ...state,
        subscriptionPlan: {
          loading: false,
          loaded: false,
          error: true,
        },
      }

    case cc.POPIN_CLOSE:
      return {
        ...state,
        subscriptionPlan: {
          loading: false,
          loaded: false,
          error: false,
        },
      }

    case sc.UPDATE_PLAN_SIMPLE_REQUEST:
      return {
        ...state,
        subscriptionPlan: {
          loading: true,
          loaded: false,
          error: false,
        },
      }

    case sc.UPDATE_PLAN_SIMPLE_SUCCESS:
      return {
        ...state,
        subscriptionPlan: {
          updated: true,
          loading: false,
          loaded: true,
          error: false,
        },
      }

    case sc.UPDATE_PLAN_SIMPLE_FAILURE:
      return {
        ...state,
        subscriptionPlan: {
          loading: false,
          loaded: false,
          error: true,
        },
      }

    case sc.GET_CURRENCY_REQUEST:
      return {
        ...state,
        currency: {
          ...state.currency,
          loading: true,
          error: null
        }

      }

    case sc.GET_CURRENCY_SUCCESS:
      return {
        ...state,
        currency: {
          ...state.currency,
          loading: false,
          data: action.response.currency,
          error: null
        }

      }

    case sc.GET_CURRENCY_FAILURE:
      return {
        ...state,
        currency: {
          ...state.currency,
          loading: false,
          error: action.error
        }
      }

    default:
      return state
  }
}
